import { render, staticRenderFns } from "./ColumnTreeTableDefaultCell.vue?vue&type=template&id=372d13fa&scoped=true"
import script from "./ColumnTreeTableDefaultCell.vue?vue&type=script&lang=js"
export * from "./ColumnTreeTableDefaultCell.vue?vue&type=script&lang=js"
import style0 from "./ColumnTreeTableDefaultCell.vue?vue&type=style&index=0&id=372d13fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372d13fa",
  null
  
)

export default component.exports